<script lang="ts">
  import type { SecondStepContactForm } from '../config/second-step';
  import { getSecondStepData } from '../model';
  import { createEventDispatcher } from 'svelte';
  import { Textarea } from '@shared/ui/fields/textarea';
  import { Select } from '@shared/ui/fields/select';
  import Noticed from './noticed.svelte';
  import { ArrowButton } from '@shared/ui/buttons/arrow-button';

  const dispatcher = createEventDispatcher();

  const sortOptions = [
    { text: 'General questions', value: 'general_questions' },
    { text: 'DLCT Guideline and licensing', value: 'dlct_guideline_and_licensing' },
    { text: 'Cooperation of Partnership', value: 'cooperation_of_partnership' },
    { text: 'Technical issues', value: 'technical_issues' },
  ];

  export let formData: SecondStepContactForm;

  const handleSubmit = () => {
    dispatcher('successSubmit', $form);
  };

  const { form, errors, enhance } = getSecondStepData(formData, handleSubmit);

  const handleSelectChange = (selectedOption: CustomEvent) => {
    $form.inquiry_type = selectedOption.detail.value;
  };
</script>

<form method="POST" class="flex flex-col" action="?/second" use:enhance>
  <Select
    on:change="{handleSelectChange}"
    state="{$errors.inquiry_type && 'error'}"
    helperText="{$errors.inquiry_type}"
    name="inquiry_type"
    label="Type of inquiry"
    options="{sortOptions}"
    isMargin
  />

  <Textarea
    bind:value="{$form.message}"
    state="{$errors.message && 'error'}"
    helperText="{$errors.message}"
    name="message"
    label="Leave a Message"
    placeholder="Message"
    containerClass="mb-8"
  />

  <Noticed />

  <ArrowButton type="submit" variant="third" classes="gap-6" slotClasses="leading-none" hugged>Contact us</ArrowButton>
</form>
